import { FormattedMessage } from "react-intl";
import { ButtonLink } from "@crunchyroll/cx-web-components";

import AccountRestrictedModal from "./AccountRestrictedModal";
import { useModal } from "../hooks";
import { CREATE_USERNAME_MODAL_QUERY_PARAM } from "../constants";
import externalLinks from "../../../constants/externalLinks";

const UsernameRestrictedModal = ({}) => {
  const { isOpen, closeModal } = useModal(CREATE_USERNAME_MODAL_QUERY_PARAM);

  return (
    <AccountRestrictedModal
      title={<FormattedMessage id="account_restricted.modal.username.title" />}
      description={
        <FormattedMessage id="account_restricted.modal.description" />
      }
      isOpen={isOpen}
      handleClose={closeModal}
      confirmBtn={
        <ButtonLink to={externalLinks.profileActivation}>
          <FormattedMessage id="account_restricted.modal.username.create_button" />
        </ButtonLink>
      }
    />
  );
};

export default UsernameRestrictedModal;
